var React = require('react');

function QuestionCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a,.b{fill:none;stroke:#000;stroke-width:1.5px;}.a{stroke-linecap:round;stroke-linejoin:round;}.b{stroke-miterlimit:10;}")),React.createElement("path",{"className":"a","d":"M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25","key":1}),React.createElement("path",{"className":"a","d":"M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0","key":2}),React.createElement("circle",{"className":"b","cx":"12","cy":"12","r":"11.25","key":3})]);
}

QuestionCircle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = QuestionCircle;

QuestionCircle.default = QuestionCircle;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/question-circle.svg
// module id = 1080
// module chunks = 0